module.exports = __webpack_public_path__ + "img/animation_sun.76ab45ca.gif";